import { createAction } from 'redux-actions'
import querystring from 'query-string'
import apiClient from '@blazar-plugins/api-client'
import { buildSearchParameters } from 'utils/parameters'

const prefix = 'quickassCategoryPicker:'

export const REQUEST_QUICKASS_CATEGORIES = `${prefix} Request quickass categories`
export const RECEIVE_QUICKASS_CATEGORIES = `${prefix} Receive quickass categories`

const requestQuickassCategories = createAction(REQUEST_QUICKASS_CATEGORIES)
const receiveQuickassCategories = createAction(RECEIVE_QUICKASS_CATEGORIES)

const fetchQuickassCategories = (query) => async (dispatch, getState) => {
  const state = getState()

  // build parameters to fetch ad counters
  const adCounterParameters = buildSearchParameters(query, {}, state.searchParams.validQueryKeys)

  const stringifiedQuery = querystring.stringify(adCounterParameters)

  // if we have the same, bail out, we don't need to fetch it again
  if (state.quickass.context === stringifiedQuery) {
    return null
  }

  dispatch(requestQuickassCategories())

  try {
    const response = await dispatch(
      apiClient.actionCreators.fetch(`classifieds/v1/ad_counters?${stringifiedQuery}&include=all`),
    )

    return dispatch(
      receiveQuickassCategories({
        context: stringifiedQuery,
        data: response,
      }),
    )
  } catch (error) {
    return dispatch(receiveQuickassCategories(error))
  }
}

export const actionCreators = {
  fetchQuickassCategories,
}
